export default __webpack_public_path__ + "static/timerbanner-82167247ff77951b8ea411752495eaef.png";